module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/BC4057-30f5b2b9fa807128e58f8a0a8bb1aaad.png";